export type ContractTerm = {
    label: string;
    online: boolean;
    value: string;
    numberOfMonths: number;
};
export enum ServiceTypes {
    TERMINAL = 'Terminal',
    ONLINE = 'Online',
    ACQUIRING_ONLY = 'Acquiring Only',
}

export enum PricingServiceTypes {
    TERMINAL = 'TERMINAL',
    ONLINE = 'ONLINE',
    ACQUIRING_ONLY = 'ACQUIRING_ONLY',
}

export enum PricingTerms {
    O12_MONTHS = '12_MONTHS',
    O18_MONTHS = '18_MONTHS',
    O24_MONTHS = '24_MONTHS',
    O36_MONTHS = '36_MONTHS',
    O48_MONTHS = '48_MONTHS',
    CUSTOM = 'CUSTOM',
}

export enum ProductType {
    ONLINE = 'ONLINE',
    TERMINAL = 'TERMINAL',
}

export type OfferProduct = {
    id: number;
    name: string;
    type?: ProductType;
    imageUrl?: string;
    price?: number;
    description?: string;
    options?: {
        oneOff?: {
            sales: number;
            commission: number | null;
        }[];
        monthly?: {
            sales: number;
            commission: number | null;
        }[];
    };
};
